// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--dzy_M","is_browser":"is_browser--Y1ROf","fadeInOut":"fadeInOut--HbdPV"};